import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authToken: "",
  loginUserDetail: {},
  main_search_list: [],
  selectedCity: "",
};

export const loginAuth = createSlice({
  name: "loginAuth",
  initialState,
  reducers: {
    getAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
    getLoginUserDetail: (state, { payload }) => {
      state.loginUserDetail = payload;
    },
    getMain_search_list: (state, { payload }) => {
      state.main_search_list = payload;
    },
    setSelectedCity: (state, action) => {
      state.selectedCity = action.payload;
    },
  },
});

export const {
  getAuthToken,
  getLoginUserDetail,
  getMain_search_list,
  setSelectedCity,
} = loginAuth.actions;

export default loginAuth.reducer;
